export default "__VITE_ASSET__B_v6N9uo__"